import { SubAreaDto } from '../../domain/entities/SubArea';
import { ApiClient } from '../api/ApiClient';

/**
 * SubAreaRepository - Implementation of subarea repository
 *
 * Handles all API calls related to subareas
 */
export class SubAreaRepository {
  constructor(private readonly apiClient: ApiClient) {}

  /**
   * Get all subareas for a specific region
   */
  async getByRegionId(regionId: string): Promise<SubAreaDto[]> {
    return this.apiClient.get<SubAreaDto[]>(`/api/regions/${regionId}/subareas`);
  }

  /**
   * Get a single subarea by ID
   */
  async getById(id: string): Promise<SubAreaDto> {
    return this.apiClient.get<SubAreaDto>(`/api/subareas/${id}`);
  }
}
